export const Physician = {
    path: '/physicians',
    name: 'physicians',
    component: () => import('@/views/Customer/PhysicianPage.vue'),
    children: [
        {
            path: '/physicians/add',
            name: 'physicians.add',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {addAction: true, type: 'physician'},
        },
        {
            path: '/physicians/edit/:id',
            name: 'physicians.edit',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {updateAction: true, type: 'physician'}
        },
        {
            path: '/physicians/delete/:id',
            name: 'physicians.delete',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {deleteAction: true, type: 'physician'}
        },
        {
            path: '/physicians/view/:id',
            name: 'physicians.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'physician'}
        },
        {
            path: '/physicians/tour_plan/add/:customerId',
            name: 'physicians.tour_plan.add',
            component: () => import('@/views/TourPlan/Form/TourPlanForm.vue'),
            props: {addAction: true},
        },
        {
            path: '/physicians/visit/add/:customerId',
            name: 'physicians.visit.add',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {addAction: true, type: 'physician'},
        },
        {
            path: '/physicians/visit/edit/:id',
            name: 'physicians.visit.edit',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {updateAction: true, type: 'physician'},
        },
        {
            path: '/physicians/visit/delete/:id',
            name: 'physicians.visit.delete',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {deleteAction: true, type: 'physician'},
        },
        {
            path: '/physicians/visit/view/:id',
            name: 'physicians.visit.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'physician'},
        },
    ]
}